import { motion } from "framer-motion";

export default function MentionsLegalesPage() {
  return (
    <div className="pt-20" data-testid="mentions-legales-page">
      <section className="bg-[#F8F9FA] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="text-4xl font-bold text-[#333333] mb-8">Mentions Légales</h1>
            
            <div className="bg-white p-8 rounded-sm shadow-sm space-y-8">
              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">1. Informations légales</h2>
                <p className="text-[#64748B] leading-relaxed">
                  <strong>Raison sociale :</strong> QUALIDECO<br />
                  <strong>Forme juridique :</strong> Entreprise individuelle / SARL (à préciser)<br />
                  <strong>Siège social :</strong> 306 rue Ampère, 71000 Mâcon, France<br />
                  <strong>Téléphone :</strong> 03 85 39 29 38<br />
                  <strong>Email :</strong> qualideco@quali-deco.fr<br />
                  <strong>SIRET :</strong> 49451505900033<br />
                  <strong>Code APE :</strong> Travaux de plâtrerie<br />
                  <strong>TVA intracommunautaire :</strong> FR29494515059
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">2. Directeur de la publication</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Le directeur de la publication du site quali-deco.fr est le représentant légal de l'entreprise QUALIDECO.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">3. Hébergement</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Ce site est hébergé par :<br />
                  <strong>Emergent Labs</strong><br />
                  Site web : emergent.sh
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">4. Propriété intellectuelle</h2>
                <p className="text-[#64748B] leading-relaxed">
                  L'ensemble du contenu de ce site (textes, images, logos, graphismes, icônes, etc.) est la propriété exclusive de QUALIDECO ou de ses partenaires. Toute reproduction, distribution, modification, adaptation, retransmission ou publication de ces éléments est strictement interdite sans l'accord exprès par écrit de QUALIDECO.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">5. Certifications professionnelles</h2>
                <p className="text-[#64748B] leading-relaxed">
                  QUALIDECO est titulaire des certifications suivantes :<br />
                  • <strong>QUALIBAT</strong> - Certification de qualification professionnelle<br />
                  • <strong>RGE (Reconnu Garant de l'Environnement)</strong> - Qualification pour les travaux d'efficacité énergétique
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">6. Assurances</h2>
                <p className="text-[#64748B] leading-relaxed">
                  QUALIDECO dispose d'une assurance responsabilité civile professionnelle et d'une garantie décennale couvrant l'ensemble de ses activités. Les attestations d'assurance sont disponibles sur demande.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">7. Limitation de responsabilité</h2>
                <p className="text-[#64748B] leading-relaxed">
                  QUALIDECO s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, QUALIDECO ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site. En conséquence, QUALIDECO décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">8. Droit applicable</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-[#333333] mb-4">9. Contact</h2>
                <p className="text-[#64748B] leading-relaxed">
                  Pour toute question concernant ces mentions légales, vous pouvez nous contacter :<br />
                  • Par email : qualideco@quali-deco.fr<br />
                  • Par téléphone : 03 85 39 29 38<br />
                  • Par courrier : QUALIDECO, 306 rue Ampère, 71000 Mâcon
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
